import classnames from 'classnames'
import PropTypes from 'prop-types'
import React from 'react'
import DatePicker from 'react-datepicker'

// import de from 'date-fns/locale/de'
// import en from 'date-fns/locale/en'
// import es from 'date-fns/locale/es'
// import fr from 'date-fns/locale/fr'
// import id from 'date-fns/locale/id'
// import it from 'date-fns/locale/it'
// import ja from 'date-fns/locale/ja'
// import pt from 'date-fns/locale/pt'
// import zh from 'date-fns/locale/zh_cn'
import 'react-datepicker/dist/react-datepicker.css'
import './DatePickerContainer.scss'

// registerLocale('de', de)
// registerLocale('en', en)
// registerLocale('es', es)
// registerLocale('fr', fr)
// registerLocale('id', id)
// registerLocale('it', it)
// registerLocale('ja', ja)
// registerLocale('pt', pt)
// registerLocale('zh', zh)

const DatePickerContainer = ({
  className, fieldId, fieldName, fieldValue, disabled, locale, isClearable, isError, dateFormat, label, labelRequired,
  isInvalid, invalidMessage, notes, callback, placeholder, minDate, maxDate
}) => {
  return (
    <div className={classnames('datepicker-container', className)}>
      {label &&
        <div className='row-label'>
          <label>{label}</label>
          {labelRequired && <strong> *</strong>}

        </div>}
      <DatePicker
        className={isInvalid ? 'is-error' : ''}
        id={fieldId}
        name={fieldName}
        disabled={disabled}
        selected={fieldValue}
        onChange={callback}
        locale='en'
        isClearable={isClearable}
        dateFormat={dateFormat}
        // dateFormat='yyyy/MM/dd'
        placeholderText={placeholder}
        minDate={minDate}
        maxDate={maxDate}

      />

      {isInvalid && invalidMessage && <p className='input_is-required_text'>{invalidMessage}</p>}
      {notes && <p className='input-note'>{notes}</p>}
    </div>
  )
}

DatePickerContainer.defaultProps = {
  fieldId: null,
  fieldValue: null,
  disabled: false,
  locale: 'en',
  isClearable: true,
  isError: false,
  // dateFormat: 'yyyy-MM-dd',
  onBlur: null
}

DatePickerContainer.propTypes = {
  fieldId: PropTypes.string,
  fieldName: PropTypes.string,
  fieldValue: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object
  ]),
  disabled: PropTypes.bool,
  locale: PropTypes.string,
  isClearable: PropTypes.bool,
  isError: PropTypes.bool,
  dateFormat: PropTypes.string,
  callback: PropTypes.func,
  label: PropTypes.string,
  labelRequired: PropTypes.bool,
  isInvalid: PropTypes.bool,
  invalidMessage: PropTypes.string,
  notes: PropTypes.string,
  selected: value => value instanceof Date,
  minDate: value => value instanceof Date,
  maxDate: value => value instanceof Date
}

export default DatePickerContainer
